mutation UpdateEventDescription($eventId: ID!, $description: String) {
  event: StreamToolsUpdateEvent(eventId: $eventId, description: $description) {
    eventId
    name
    description
  }
}
